import { QueryClient } from '@tanstack/react-query';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: Infinity,
      gcTime: 1000,
      refetchOnWindowFocus: false,
    },
  },
});

export default queryClient;
